@if(documentDataUrl) {
    <iframe class="w-full h-full rounded-md"
            loading="lazy"
            referrerpolicy="no-referrer"
            [src]="documentDataUrl">
    </iframe>
}
